<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" placeholder="搜索名称"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="状态">
              <a-select v-model="queryParam.status" placeholder="请选择"
                        allowClear >
                <a-select-option value="1">进行中</a-select-option>
                <a-select-option value="3">未开始</a-select-option>
                <a-select-option value="4">已结束</a-select-option>
                <a-select-option value="2">已下架</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd" >新建</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="setAllStatus(1)" key="1"><a-icon type="upload" />上架</a-menu-item>
          <a-menu-item @click="setAllStatus(2)" key="2"><a-icon type="download" />下架</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <span slot="title1" slot-scope="text,record">
        <div style="margin-bottom: 10px;">{{record.title}}</div>
        <div>
          <img style="width: 68px ; height: 68px; float: left" :src="record.pic_url" />
          <div style="color: #999;margin-left: 10px; float: left">
            最高减 <span style="color: #f5212d">¥{{record.pen_price|price}}</span>
            <br/>
            刀数: {{record.pen_data.length}}
            <br/>
            <a-badge status="success" v-if="record.status==1" text="进行中" />
            <a-badge status="processing" v-else-if="record.status==3" text="未开始" />
            <a-badge status="default" v-else-if="record.status==4" text="已结束" />
            <a-badge status="default" v-else text="已下架" />
          </div>
        </div>
      </span>
      <span slot="timeRange" slot-scope="text,record">
        <template >
        <div>
          开始:{{record.time_start|timeFormat}}<br/>
          结束:{{record.time_end|timeFormat}}
        </div>
          </template>
      </span>
      <span slot="orderCount" slot-scope="text,record">
        <template >
        <div>
          {{record.order_count}}/{{record.join_count}}/{{record.apply_count}}
        </div>
        </template>
      </span>
      <span slot="userGetNumLimit" slot-scope="text,record">
        <template >
        <div>
          <span v-if="record.user_get_num_limit>0" >每人{{record.user_get_num_limit}}张</span>
          <span v-else  >不限制</span>
          <br/>
          <span>库存{{record.count}}</span>
        </div>
        </template>
      </span>
      <span slot="action" slot-scope="text,record">
        <template >
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
        <a-dropdown>
          <a class="ant-dropdown-link">
            更多 <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item>
          <a @click="handleUserManage(record)">砍价记录</a>
            </a-menu-item>
            <a-menu-item>
            <a href="javascript:;" @click="onShare(record)">小程序推广</a>
            </a-menu-item>
             <a-menu-item>
                <a href="javascript:;" @click="onH5Share(record)">H5版推广</a>
              </a-menu-item>
            <a-menu-item>
          <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="deleteHandle(record)"  okText="确定" cancelText="取消">
            <a href="javascript:;">删除</a>
          </a-popconfirm>
            </a-menu-item>
          </a-menu>
        </a-dropdown>

        </template>
      </span>
    </s-table>
    <a-modal
            title="操作"
            :width="1000"
            style="top: 20px;"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="visible"
            @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">

          <a-form-item
                  label="所属商品"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
          >
            <a-select
                    showSearch
                    v-model="formData.goods_id"
                    optionFilterProp="title"
                    :disabled="formData.id>0"
                    @change="goodsChange"
                    placeholder="选择商品"
            >
              <a-select-option :key="option.id" :title="option.title" v-for="option in goodsOptions" :disabled="option.disabled" :value="option.id">{{option.title}}</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="标题"
                  hasFeedback
          >
            <a-input v-decorator="[
          'title',
          {rules: [{ required: true, message: '请输入优惠券标题' }]}
        ]"
                     placeholder="请输入优惠券标题"/>
          </a-form-item>

          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="活动时间"
                  hasFeedback
          >
            <a-range-picker
                    v-model="formData.time_range_moment"
                    :showTime="{
        defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
      }"
                    format="YYYY-MM-DD HH:mm:ss"
            />
          </a-form-item>


          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="帮砍时限"
                  hasFeedback
                  extra="用户发起砍价后，在此时间内才可以邀请好友进行砍价，单位小时"
          >
            <a-input type="number" v-decorator="[
          'time_limit',
          {rules: [{ required: true, message: '请输入帮砍时间限制(小时)'}]}
        ]"
                     placeholder="请输入帮砍时间限制(小时)"/>
          </a-form-item>

          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="成功类型"
                  hasFeedback
          >
            <a-radio-group v-model="formData.success_type"   buttonStyle="solid">
              <a-radio-button :value="1">到时砍价成功</a-radio-button>
              <a-radio-button :value="2">价格到底砍价成功</a-radio-button>
            </a-radio-group>
          </a-form-item>


          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="下单时限"
                  hasFeedback
                  extra="帮砍结束后,在此时间内下单有效，单位小时"
          >
            <a-input type="number" v-decorator="[
          'buy_time_limit',
          {rules: [{ required: true, message: '请输入下单时间限制(小时)' }]}
        ]"
                     placeholder="请输入下单时间限制(小时)"/>
          </a-form-item>

          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="仅限新用户发起"
                  hasFeedback
          >
            <r-switch :formData="formData" field="only_new_user" :checkedValue="1" :unCheckedValue="2" checkedChildren="是" unCheckedChildren="否" />
          </a-form-item>

          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="仅限新用户帮砍"
                  hasFeedback
          >
            <r-switch :formData="formData" field="only_new_user_help" :checkedValue="1" :unCheckedValue="2" checkedChildren="是" unCheckedChildren="否" />
          </a-form-item>

          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="帮砍赠送优惠券"
                  hasFeedback
          >
            <r-switch :formData="formData" field="youhuiquan_status" @change="youhuiquanStatusChange" :checkedValue="1" :unCheckedValue="2" checkedChildren="是" unCheckedChildren="否" />
          </a-form-item>

          <a-form-item
                  v-show="formData.youhuiquan_status==1"
                  label="优惠券"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
          >
            <a-select
                    showSearch
                    v-model="formData.youhuiquan_id"
                    optionFilterProp="title"
                    placeholder="选择优惠券"
            >
              <a-select-option :key="option.id" v-for="option in youhuiquanOptions" :title="option.title" :disabled="option.disabled" :value="option.id">{{option.title}}</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item
                  v-show="formData.youhuiquan_status==1"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="优惠券额度"
                  hasFeedback
          >
            <a-radio-group v-model="formData.youhuiquan_mode" buttonStyle="solid">
              <a-radio-button :value="1">以砍价金额为准(请选择随机券)</a-radio-button>
              <a-radio-button :value="2">以优惠券金额为准</a-radio-button>
            </a-radio-group>
          </a-form-item>


          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="帮砍加好友"
                  hasFeedback
          >
            <r-switch :formData="formData" field="add_friend_status" @change="addFriendStatusChange" :checkedValue="1" :unCheckedValue="2" checkedChildren="是" unCheckedChildren="否" />
          </a-form-item>

          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  v-if="formData.add_friend_status==1"
                  label="客服微信号"
                  hasFeedback
          >
            <a-input v-decorator="[
          'add_friend_wxcode',
          {rules: []}
        ]"
                     placeholder="请输入客服微信号"/>
          </a-form-item>
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="客服微信二维码"
                  v-if="formData.add_friend_status==1"
                  hasFeedback
          >
            <pic-uploader
                    :file-list="formData.add_friend_wxqrcode"
            />
          </a-form-item>

          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="加好友话术"
                  v-if="formData.add_friend_status==1"
                  hasFeedback
          >
            <a-input v-decorator="[
          'add_friend_note',
          {rules: []}
        ]"
                     placeholder="请输入加好友话术"/>
          </a-form-item>

          <a-form-item
                  v-show="formData.youhuiquan_status==1"
                  :labelCol="labelCol"
                  v-if="false"
                  :wrapperCol="wrapperCol"
                  label="关注二维码"
                  hasFeedback
                  extra="提示用户关注二维码了解如何使用优惠券"
          >
            <pic-uploader
                    :file-list="formData.qr_code_pic"
            />
          </a-form-item>


          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="数量限制"
                  hasFeedback
                  :extra="'不能超过商品的库存,用户已发起'+formData.order_count+',剩余'+(formData.buy_limit-formData.order_count)"
          >
            <a-input type="number" v-decorator="[
          'buy_limit',
          {rules: []}
        ]"
                      placeholder="请输入数量限制"/>
          </a-form-item>

          <a-form-item
                  label="砍价配置"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  :extra="'最多砍去'+pen_price/100+'元'"
          >
            <div v-for="(item,k) in formData.pen_data" style="margin-bottom: 10px;" :key="k">
              <span style="width: 80px;display: block;float: left;">第{{k+1}}刀</span>

              <PriceInput style=" width: 150px;margin: 4px 10px 0 10px;float: left;" :formData="item"
                          field="amount"
                          placeholder="请填写值"/>

              <!--<a-input style=" width: 150px;margin: 4px 10px 0 10px;float: left;" v-model="item.amount" placeholder="请填写值"/>-->
              <a-icon style="float: left;margin-top: 12px;"
                      class="dynamic-delete-button"
                      type="minus-circle-o"
                      @click="() => removeExtraField(k)"
              />
              <div style="clear: both"></div>
            </div>
            <div><a-button
                    style="width: 270px"
                    type="dashed"
                    @click="addExtraField"
            >
              <a-icon type="plus" /> 新增一刀
            </a-button></div>
            </a-form-item>
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="状态"
                  hasFeedback
          >
            <r-switch  :formData="formData" field="status" :checkedValue="1" :unCheckedValue="2"  checkedChildren="上架" unCheckedChildren="下架" />
          </a-form-item>


          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="规则说明"
                  hasFeedback
          >
            <a-textarea :autosize="{ minRows: 2, maxRows: 6 }"  v-decorator="[
          'rule_note',
          {rules: []}
        ]"
                     placeholder="请输入规则说明"/>
          </a-form-item>
        </a-form>


      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>


    <a-modal
            title="参与记录"
            :width="1000"
            style="top: 20px;"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="userVisible"
            @ok="userVisible=false"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-table :columns="userColumns" :dataSource="kanjiaUserList" :pagination="userPagination"
                   @change="handleUserTableChange"
                   rowKey="id" :scroll="{ y: 300 }" bordered>
            <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm}" class='custom-filter-dropdown'>
              <a-input
                      v-model="userQuery.keywords"
                      placeholder="搜索用户名/手机号"
                      style="width: 188px; margin-bottom: 8px; display: block;"
              />
              <a-button
                      type='primary'
                      @click="userSearch(selectedKeys, confirm)"
                      icon="search"
                      size="small"
                      style="width: 90px; margin-right: 8px"
              >搜索</a-button>
              <a-button
                      @click="userSearchReset(selectedKeys, confirm)"
                      size="small"
                      style="width: 90px"
              >重置</a-button>
            </div>
            <span slot="name" slot-scope="text,record">
              {{record.user_name}}
            </span>
            <span slot="member_count" slot-scope="text,record">
              {{record.member_count}}
            </span>
            <span slot="pen_price" slot-scope="text,record">
              {{record.pen_price|price}}
            </span>
            <span slot="status" slot-scope="text,record">
            <a-badge status="processing" v-if="record.status==1" text="进行中" />
            <a-badge status="success" v-else-if="record.status==2" text="完成" />
            <a-badge status="error" v-else-if="record.status==3" text="过期失败" />
            <a-badge status="default" v-else-if="record.status==4" text="已下单" />
            </span>
            <span slot="time_start" slot-scope="text,record">
            开始:{{record.time_start|timeFormat}}<br/>
            结束:{{record.time_end|timeFormat}}<br/>
            下单:{{record.order_time|timeFormat}}
            </span>
          </a-table>
        </a-form>
      </a-spin>
      
    </a-modal>

    <a-modal title="小程序推广" v-model="shareVisible" @ok="shareVisible=false">
      <p style="text-align: center">
        <img :src="share.wxmini_pic_url" />
      </p>
    </a-modal>
    <a-modal title="H5推广" v-model="h5ShareVisible" @ok="h5ShareVisible=false">
      <p style="text-align: center">
        <img :src="share.wxmini_pic_url" />
      </p>
      <p>详情地址</p>
      <p>{{share.site_url}} </p><a  
        v-clipboard:copy="share.site_url"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError">点此复制</a>
    </a-modal>
  </a-card>
</template>

<script>
  import STable from '@/components/table/'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import AInput from 'ant-design-vue/es/input/Input'
  import EditableCell from '@/components/EditableCell/'
  import RSwitch from '@/components/RSwitch/'
  import PicUploader from '@/components/PicUploader/'
  import PriceInput from '@/components/PriceInput/'
  import moment from 'moment'
  import 'moment/locale/zh-cn';
  moment.locale('zh-cn');
  import { getGoodsOptions,getKanjiaList,getKanjiaDetail,addKanjia,editKanjia,deleteKanjia,setKanjiaAllStatus,getYouhuiquanOptions,getKanjiaUserList } from '@/api/kanjia';
  export default {
    name: 'CouponList',
    components: {
      AInput,
      ATextarea,
      STable,
      EditableCell,
      RSwitch,
      PriceInput,
      PicUploader
    },
    data () {
      return {
        visible: false,
        saveLoading:false,
        userVisible:false,
        shareVisible: false,
        h5ShareVisible:false,
        share:{
          wxmini_pic_url:'',
          site_url:''
        },
        formData:{
          title: '',
          youhuiquan_status: 2,
          youhuiquan_mode: 1,
          time_range:[],
          time_range_moment:[],
          qr_code_pic:[],
          youhuiquan_id:'',
          time_limit:6,
          buy_time_limit:6,
          order_count:0,
          buy_limit : 0,
          user_buy_limit : 0,
          only_new_user : 2,
          only_new_user_help : 2,
          pen_data : [],
          add_friend_wxqrcode : [],
          add_friend_status:2,
          add_friend_wxcode : '',
          add_friend_note : '',
          rule_note : '',
          pen_price : '',
          success_type : 1,
          goods_id: '',
          status: 1
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        mdl: {},

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
          keywords:'',
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '50px'
          },
          {
            title: '标题',
            dataIndex: 'title',
            scopedSlots: { customRender: 'title1' },
          },
          {
            width:'250px',
            title: '活动时间',
            dataIndex: 'time_start',
            scopedSlots: { customRender: 'timeRange' },
          },
          {
            title: '下单/参与/发起',
            width:'150px',
            dataIndex: 'order_count',
            scopedSlots: { customRender: 'orderCount' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            width: '180px',
            scopedSlots: { customRender: 'action' },
          }
        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          console.log('loadData');
          console.log(this.queryParam);
          this.queryParam = Object.assign( this.queryParam,parameter);
          return getKanjiaList(this.queryParam)
            .then(res => {
              console.log('res');
              return res.data
            })
        },

        selectedRowKeys: [],
        selectedRows: [],
        goodsOptions:[],
        youhuiquanOptions:[],
        //领取人员表头
        userColumns: [
  {
    title: '#',
    dataIndex: 'id',
    width: '100px'
  },
  {
    title: '发起人',
    dataIndex: 'user_name',
    width:'150px',
    scopedSlots: {
      filterDropdown: 'filterDropdown',
      filterIcon: 'filterIcon',
      customRender: 'name',
    }
  },
  {
    title: '帮砍人数',
    width:'100px',
    dataIndex: 'member_count',
    scopedSlots: {
      customRender: 'member_count',
    },
  },
  {
    title: '优惠',
    width:'100px',
    dataIndex: 'pen_price',
    scopedSlots: {
      customRender: 'pen_price',
    },
  },
  {
    title: '状态',
    width:'100px',
    dataIndex: 'status',
    scopedSlots: {
      customRender: 'status',
    },
    filters: [
      {
        text: '进行中',
        value: '1'
      },
      {
        text: '完成',
        value: '2'
      },
      {
        text: '过期失败',
        value: '3'
      },
      {
        text: '已下单',
        value: '4'
      }],
    filterMultiple:false,
  },
  {
    title: '时间',
    width:'150px',
    dataIndex: 'time_start',
    scopedSlots: {
      customRender: 'time_start',
    },
  },
],
        userPagination:{
          pageSize: 30,
          pageNo: 1,
          showTotal: total => {
            return '总计' + total + '条'
          }
        },
        userQuery:{
          kanjia_id:0,
          status:0,
          pageNo:1,
          keywords:undefined
        },
        kanjiaUserList:[]
      }
    },
    computed: {
          pen_price : function () {
              var result = 0;
              for(var i = 0; i < this.formData.pen_data.length; i++) {
                  result += parseFloat(this.formData.pen_data[i].amount);
              }
              return result;
          }
      },
    created(){
    },
    mounted(){
      let that = this;
      that.getGoodsOptions();
      that.getYouhuiquanOptions();
    },
    methods: {
      moment,
      handleCancel(){
        this.visible = false
      },
      // 增
      handleAdd() {
        console.log('moment.locale()')
        console.log(moment.locale());
        let that = this;
        that.getGoodsOptions();
        this.visible = true;
        this.form.resetFields();
        this.formData = {
          title: '',
          youhuiquan_status: 2,
          youhuiquan_mode: 1,
          time_range:[],
          time_range_moment:[],
          qr_code_pic:[],
          youhuiquan_id:'',
          time_limit:6,
          buy_time_limit:6,
          order_count:0,
          buy_limit : 0,
          user_buy_limit : 0,
          only_new_user : 2,
          only_new_user_help : 2,
          pen_data : [],
          pen_price : '',
          goods_id: undefined,
          add_friend_wxqrcode : [],
          add_friend_status:2,
          add_friend_wxcode : '',
          add_friend_note : '',
          rule_note : '',
          success_type : 1,
          status: 1
        };
        setTimeout( () =>{
          that.form.setFieldsValue({ ...this.formData });
        });
      },
      // 改
      handleEdit(record) {
        let self = this
        getKanjiaDetail({ id: record.id }).then(res => {
          setTimeout(()=>{
            self.form.setFieldsValue({ ...res.data })
          },1)
//          self.formData = {...res.data};
          self.formData = Object.assign(self.formData, res.data) //尼玛 日期选择器有bug 必须这样赋值
          self.formData.id = res.data.id;
          self.formData.time_range_moment = [moment(res.data.time_start*1000),moment(res.data.time_end*1000)];
        })
        this.visible = true
      },

      // 增改 处理
      handleOk(e) {
        let self = this;
        e.preventDefault()
        this.form.validateFields((err, values) => {
          if (!err) {
            if(!self.formData.goods_id){
              self.$message.error('请选择商品');
              return ;
            }
            if(self.formData.time_range_moment.length!=2){
              self.$message.error('请选择时间范围');
              return ;
            }
            if(self.formData.youhuiquan_status==1){
              if(!self.formData.youhuiquan_id){
                  self.$message.error('请选择一张优惠券');
                  return ;
              }
            }else{
              self.formData.youhuiquan_id = '';
            }
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.formData)
            self.saveLoading = true;
            let formData = {
              id:self.formData.id,
              title: values.title,
              goods_id:self.formData.goods_id,
              time_range:[self.formData.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),self.formData.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')],
              user_buy_limit: values.user_buy_limit,
              buy_limit: values.buy_limit,
              youhuiquan_id: self.formData.youhuiquan_id,
              time_limit: values.time_limit,
              buy_time_limit: values.buy_time_limit,
              only_new_user: self.formData.only_new_user,
              only_new_user_help: self.formData.only_new_user_help,
              pen_data:self.formData.pen_data,
              qr_code_pic:self.formData.qr_code_pic,
              youhuiquan_mode:self.formData.youhuiquan_mode,
              add_friend_wxqrcode : self.formData.add_friend_wxqrcode,
              add_friend_status:self.formData.add_friend_status,
              add_friend_wxcode : values.add_friend_wxcode,
              add_friend_note : values.add_friend_note,
              rule_note : values.rule_note,
              status:self.formData.status,
              success_type:self.formData.success_type,
            };
            if(self.formData.id) {
              editKanjia(formData).then(res => {
                self.$message.success('修改成功')
                self.$refs.table.refresh(true)
                self.visible = false;
                self.saveLoading = false;
              }).catch(err =>{
                self.$message.error(err.data.msg);
                self.saveLoading = false;
              })
            }else{
              addKanjia(formData).then(res => {
                self.$message.success('新增成功')
                self.$refs.table.refresh(true)
                self.visible = false
                self.saveLoading = false;
              }).catch(err =>{
                self.$message.error(err.data.msg);
                self.saveLoading = false;
              })
            }
          }
        })
      },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(true)
    },
      setAllStatus(status){
        let self = this;
        setKanjiaAllStatus({
          ids:self.selectedRowKeys,
          status:status,
        })
                .then(res => {
                  self.$message.success('设置成功')
                  self.$refs.table.refresh(true)
                })
      },
     // 删
      deleteHandle(record) {
        let self = this
        deleteKanjia({ id: record.id }).then(res => {
          self.$message.success('删除成功')
          self.$refs.table.refresh(true)
      }).catch(err =>{
          self.$message.error(err.data.msg)
        })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
      addExtraField(){
        if(this.formData.pen_data.length &&  this.formData.pen_data[this.formData.pen_data.length-1].amount ==''){
          return false;
        }
        this.formData.pen_data.push({'amount':''});
      },
      removeExtraField(k){
        this.formData.pen_data.splice(k,1);
      },
    getGoodsOptions(){
        let self = this;
        getGoodsOptions( ).then(res => {
          self.goodsOptions = res.data;
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },
      getYouhuiquanOptions(){
        let self = this;
        getYouhuiquanOptions( ).then(res => {
          self.youhuiquanOptions = res.data;
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },

      goodsChange(goods_id){
        console.log(goods_id)
        if(!goods_id){
          return ;
        }
        let that = this
        let selectGoods = that.goodsOptions.filter(goods=>{
          return goods.id ==goods_id;
        });
        that.formData.title=selectGoods[0].title;
        that.form.setFieldsValue({ title:selectGoods[0].title})
      },



      handleUserManage(record) {
        let self = this
        self.userQuery.kanjia_id = record.id;
        self.userQuery.keywords = undefined;
        self.userQuery.status = undefined;
        self.userPagination.p = 1;
        self.fetchUserList();
        this.userVisible = true
      },

      fetchUserList(){
        let self = this
        getKanjiaUserList(Object.assign(self.userQuery,self.userPagination)).then(res => {
          self.kanjiaUserList = res.data.list
          const pagination = { ...this.userPagination }
          pagination.total = res.data.total
          self.userPagination = pagination

        })
      },

      userSearch(selectedKeys,confirm){
        let self = this
        confirm();
        self.fetchUserList();
      },
      userSearchReset(selectedKeys,confirm){
        let self = this;
        confirm();
        self.userQuery.keywords = undefined;
        self.fetchUserList();
      },
      handleUserTableChange(pagination, filters, sorter) {
        console.log('filters',filters);
        let that = this;
        if(filters.status){
          that.userQuery.status = filters.status[0];
        }else{
          that.userQuery.status = 0;
        }
        const pager = { ...this.pagination }
        pager.current = pagination.current
        that.pagination = pager
        that.userQuery.pageNo = pagination.current
        pager.pageNo = pagination.current
        that.userPagination = pager

        that.fetchUserList();
      },
      onShare(record){
        let that = this;
        that.shareVisible = true; 
        that.share.wxmini_pic_url = record.wxmini_pic_url;
      },
       onH5Share(record) {
        console.log(record)
        let that = this
        that.h5ShareVisible = true
        that.share.site_url=record.h5_url
        that.share.wxmini_pic_url = record.h5_pic_url
      },
      onCopy(e){
      this.$message.success('复制成功')
      },
      onError(e){
        this.$message.error('复制失败')
      },
      youhuiquanStatusChange(value){
        console.log('youhuiquanStatusChange',value);
        if(value==1){
          //是
          this.formData.add_friend_status = 2
        }else{
          //否
        }
      },
      addFriendStatusChange(value){
        console.log('addFriendStatusChange',value);
        if(value==1){
          //是
          this.formData.youhuiquan_status = 2
        }else{
          //否
        }
      }
    },
    watch: {
      /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
    }
  }
</script>


<style scoped>
  .custom-filter-dropdown {
    padding: 8px;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .15);
  }

  .highlight {
    background-color: rgb(255, 192, 105);
    padding: 0px;
  }
</style>